import React from "react";
import { Link } from "react-router-dom";
import { Crown, Swords, Users, ArrowRight } from "lucide-react";

/**
 * Full-screen Plyx-feed promo slide for Plyx Millions. Interleaved into
 * the swipeable feed every ~20 slides (see PlyxFeed). Tap anywhere → game.
 */
const LADDER_PREVIEW = [
  { n: 8, amt: "1,000,000" },
  { n: 7, amt: "500,000" },
  { n: 6, amt: "125,000" },
  { n: 5, amt: "32,000" },
  { n: 4, amt: "8,000" },
];

const MillionsFeedCard = () => (
  <Link
    to="/plyx/millions"
    className="relative h-full w-full overflow-hidden flex flex-col items-center justify-center text-white"
    data-testid="plyx-feed-millions-card"
    style={{
      background:
        "radial-gradient(circle at 80% 8%, rgba(255,180,45,0.28) 0%, transparent 45%), radial-gradient(circle at 12% 88%, rgba(255,45,122,0.25) 0%, transparent 45%), #0a0a14",
    }}
  >
    <div className="absolute top-6 left-1/2 -translate-x-1/2 inline-flex items-center gap-2 px-3 py-1 rounded-full bg-black/55 backdrop-blur border border-[#FFB42D]/30 text-[10px] uppercase tracking-[0.3em] font-bold text-[#FFB42D]">
      <Crown className="w-3 h-3" /> Plyx Millions
    </div>

    <div className="px-6 text-center max-w-md">
      <div className="text-5xl mb-3">💰</div>
      <h2 className="text-3xl sm:text-4xl font-extrabold leading-tight">
        Could you climb to <span className="text-[#FFB42D]">1,000,000</span>?
      </h2>
      <p className="mt-3 text-sm text-white/70 leading-relaxed">
        8 Millionaire-standard questions. Two lifelines. Wrong answers don&apos;t end
        your run — score big, duel rivals for coin pots, squad up in team battles,
        and put your country&apos;s flag on top of the Nations League.
      </p>

      <div className="mt-5 flex flex-col gap-[3px] max-w-[220px] mx-auto">
        {LADDER_PREVIEW.map((r, i) => (
          <div
            key={r.n}
            className={`flex items-center justify-between px-3 py-1 rounded-md text-[11px] font-bold ${
              i === 0 ? "bg-[#FFB42D] text-black" : "bg-white/[0.06] text-white/60"
            }`}
          >
            <span>{r.n}</span>
            <span>{r.amt}</span>
          </div>
        ))}
      </div>

      <div className="mt-5 flex items-center justify-center gap-2 text-[11px] font-bold text-white/75 flex-wrap">
        <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-white/10">
          <Crown className="w-3 h-3 text-[#FFB42D]" /> Solo Climb
        </span>
        <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-white/10">
          <Swords className="w-3 h-3 text-[#00E0C7]" /> 1v1 Duel
        </span>
        <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-white/10">
          <Users className="w-3 h-3 text-[#FF2D7A]" /> Team Battle
        </span>
      </div>

      <span className="mt-6 inline-flex items-center gap-2 px-7 py-3 rounded-full bg-gradient-to-r from-[#FF2D7A] via-[#FFB42D] to-[#00E0C7] text-black font-extrabold text-sm">
        Play now <ArrowRight className="w-4 h-4" />
      </span>
    </div>
  </Link>
);

export default MillionsFeedCard;
